import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import Spinner from "reactjs-simple-spinner";
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import {makeStyles} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {toast, ToastContainer} from "react-toastify";
import SettingsService from "../../../services/SettingsService";


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));

const BeefPrice = (props) => {

    const [loading, setLoading] = useState(true);
    const [updateLoading, setUpdateLoading] = useState(false);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [errorMessage, setErrorMessage] = useState('')

    const [price, setPrice] = useState(0.00)

    const updateBeefPrice = () => {
        setUpdateLoading(true);
        console.log(price);

        let request = {"beef_price": parseFloat(price).toFixed(2)}

        console.log("request payload: ", request);

        SettingsService.updateSettings(request).then(res => {
            console.log("res: ", res)
            if (res.status === 200) {
                SettingsService.getSettings().then(response => {
                    console.log(response);
                    if (response === undefined) {

                        toast.warning('✅ Beef Price Updated, 🚫 Failed to get data ', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                        setUpdateLoading(false);
                    }

                    setPrice(response.data.data[0].beef_price)

                    toast('✅ Beef Price Updated ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);

                    //   console.log();                                                                                        );
                }).catch(err => {
                    console.log(err);
                    toast.warning('✅ Beef price Updated , 🚫 Failed to get data ', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                });

            } else {
                toast.warning('🚫 Failed to update beef price ' + res.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            }
        })
            .catch((err) => {
                console.log("error: ", err)
                toast.warning('🚫 Failed to update beef price ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setUpdateLoading(false);
            })

    }

    useEffect(() => {
        setLoading(true);
        setUpdateLoading(false);
        SettingsService.getSettings()
            .then(res => {
                console.log(res)
                if (res === undefined) {
                    setLoading(false)
                }
                setPrice(res.data.data[0].beef_price)
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false)
            })
    }, [])

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                <div className="content">
                    <div className="container-fluid">
                        <div className="container">
                            {loading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="large"
                                        message="Please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>
                            )}
                            {updateLoading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="large"
                                        message="Updating Price, Please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>
                            )}

                            {!loading && !updateLoading && (
                                <div className="main-body">

                                    <nav aria-label="breadcrumb" className="main-breadcrumb">
                                        <ol className="breadcrumb">
                                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a>
                                            </Link>
                                            &nbsp;|&nbsp;
                                            <Link to="/settings"><a href><i
                                                className="fa fa-cog"/>&nbsp;Settings</a></Link>
                                            &nbsp;|&nbsp;
                                            <li className="breadcrumb-item active" aria-current="page">Beef Price
                                                Management
                                            </li>
                                        </ol>
                                    </nav>


                                    <div className="row gutters-sm">
                                        <div className="container col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex flex-column align-items-center text-center">
                                                        <h2 className="text-primary h2">Update Beef Price / Kg</h2>
                                                        <div className="mt-3">
                                                            <h4>Current Beef Price / Kg</h4>
                                                            <label className="text-success mb-1">${price}</label>
                                                        </div>
                                                        <hr/>
                                                        <div className="mt-3">
                                                            <TextField
                                                                type="number"
                                                                autoComplete="off"
                                                                aria-autocomplete={false}
                                                                className="mb-3"
                                                                label="Price $/kgs"
                                                                fullWidth
                                                                required
                                                                name="beef_price"
                                                                placeholder={'0.00'}
                                                                onChange={(e) => setPrice(e.target.value)}
                                                            />
                                                        </div>
                                                        <button
                                                            onClick={updateBeefPrice}
                                                            className="btn btn-sm btn-primary">
                                                            Update Beef Price / Kg
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default BeefPrice;
